"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FileSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M17 11V2H7a2 2 0 00-2 2v24a2 2 0 002 2h18a2 2 0 002-2V12h-9a1 1 0 01-1-1zm-7 4h6a1 1 0 010 2h-6a1 1 0 010-2zm12 10H10a1 1 0 010-2h12a1 1 0 010 2zm1-5a1 1 0 01-1 1H10a1 1 0 010-2h12a1 1 0 011 1z"/><path d="M26.8 10a3.4 3.4 0 00-.8-1.4l-.3-.3-5-5-.3-.3a3.4 3.4 0 00-1.4-.8V10z"/>';
var FileSVG = function FileSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.FileSVG = FileSVG;
FileSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FileSVG);
exports.default = _default;